	let order_id = newOrderId();
const proxy_loc = "https://data.skymap.website/";
// const proxy_loc = window.location.origin;
// Twemoji 17.0.2 images self-hosted on our server, the same files the print uses
// (twemoji builds base + folder + '/' + icon + ext)
const twemoji_options = { base: 'https://data.skymap.website/static/twemoji/17.0.2/', folder: '72x72', ext: '.png' }
var preview_thumb_upload = 'https://cdn.shopify.com/s/files/1/0511/8522/1811/files/download_9.png'
var image_upload_file = preview_thumb_upload;

var qr_url = '';
var qr_pending = false;

var map_color_present = '';

// cart lines as {key, variant_id, quantity, order_id}, to reopen an edited line on its product and replace it
var cart_lines = []
var cart_loaded = Promise.resolve()

// The cart line opened via ?order_id= (edit flow) as {order_id, variant_id}: add-to-cart replaces it. It is found by
// OrderID + variant, not by its key: Shopify shows a qty-2 line as two lines (the "1+1" discount is on one unit) and
// merges them back, with new keys each time. The edited map is saved under this page's own OrderID, so those lines
// and their saved design stay as they are until the new line is in the cart.
var edit_line = null

// ?order_id= whose saved map could not be loaded: initMap then syncs the date labels as on a fresh page
var saved_map_missing = false

function newOrderId(){
  return Math.random().toString(36).slice(2);
}

function setCartOrderIds(cart){
  cart_lines = cart.items.map(x=>({ key: x.key, variant_id: x.variant_id, quantity: x.quantity, order_id: x.properties ? x.properties.OrderID : undefined }))
}

// [type, size, frame] of a variant of this product, from the variant select ("Tablou / Large 50x70cm / Alba - 219,99 lei")
function variantOptions(variant_id){
  var title = $('#product-select option').filter(function(){ return variant_id && this.value == variant_id }).first().text().trim()
  if(title.lastIndexOf(' - ') < 0){
    return null
  }
  return title.slice(0, title.lastIndexOf(' - ')).split(' / ')
}

// The Sky Light type is only offered on the Sky Light style (the others hide it, and that style is sold out)
function typeOffered(state){
  return state != 'Sky_Light__picker' || $('.style_picker .active__picker').index() == 2
}

// [type, size] of a saved map's size ("50x70", as submit_form saves it): Tablou when it has that size,
// else the first type that has it. The frame stays the type's first one.
function sizeOptions(size){
  var found = null
  $('.state_1').each(function(){
    var state = $(this).attr('data-state'),
    type = $(this).find('.info__picker p').text().trim()
    if(!typeOffered(state)){
      return
    }
    $('.state__picker.state_2').filter(function(){ return $(this).attr('data-state') == state }).find('.info__picker p').each(function(){
      var text = $(this).text().trim()
      if(size && (text.split(' ')[1] || '').replace('cm','') == size && (!found || state == 'Tablou__picker')){
        found = [type, text]
      }
    })
  })
  return found
}

// Select [type, size, frame] in the final-step pickers (they set the variant select and #var_id). A size or frame
// the pickers do not offer (Mini) keeps the type's first one. Returns false when the type is not offered.
function selectVariantPickers(options){
  var type = $('.state_1').filter(function(){ return options && $(this).find('.info__picker p').text().trim() == options[0] && typeOffered($(this).attr('data-state')) }).first()
  if(!type.length){
    return false
  }
  type.click()
  var state = $('.state__picker').filter(function(){ return $(this).attr('data-state') == type.attr('data-state') })
  state.filter('.state_2').find('.elem__picker').filter(function(){ return $(this).find('.info__picker p').text().trim() == options[1] }).click()
  state.filter('.state_3').find('.elem__picker').filter(function(){ return $(this).find('.info__picker p').text().trim() == options[2] }).click()
  return true
}

// A saved lat / long ("44.43 N", as submit_form saves it) is a location the customer chose (a place or typed
// coordinates), not the page's default New York values, which are saved when no place was ever picked
function savedLocationChosen(lat, long){
  var input_default = function(id){
    return $(id+' input').prop('defaultValue')+' '+($(id+' select option[selected]').val() || $(id+' select option').first().val())
  }
  lat = $.trim(lat)
  long = $.trim(long)
  return !isNaN(parseFloat(lat)) && !isNaN(parseFloat(long)) && (lat != input_default('#custom_lat_input') || long != input_default('#custom_lng_input'))
}

// Add-to-cart starts disabled ("Selectează locaţia") until the map has a location
function enableAddToCart(){
  $('.submit__form').css({
    "opacity": "1",
    "pointer-events": "auto"
  }).find('.custom_text').text($('.add_to_cart_text').val())
}

// Re-read the cart (the copy loaded at page load is stale after Back / bfcache or edits in another tab)
function refreshCartOrderIds(){
  return fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => setCartOrderIds(cart))
    .catch((error) => console.error('Error:', error));
}

// cart lines (as setCartOrderIds keeps them) of the edited design: its OrderID on its variant
function editedLines(lines){
  return lines.filter(x => edit_line && x.order_id == edit_line.order_id && x.variant_id == edit_line.variant_id)
}

// Remove every cart line of the edited design, one cart/change.js at a time, each on the cart the previous call
// returned: the add and each removal re-apply the discounts, so Shopify can split, merge and re-key those lines
async function removeEditedLines(){
  // the cart after the add (if this read fails, the copy read before the add)
  await refreshCartOrderIds()
  for(var i = 0; i < 10; i++){
    var line = editedLines(cart_lines)[0]
    if(!line){
      return
    }
    const changeResp = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            'id': line.key,
            'quantity': 0
        })
    });
    if(!changeResp.ok){
        throw new Error('cart/change.js '+changeResp.status)
    }
    var cart = await changeResp.json()
    if(cart && cart.items){
        setCartOrderIds(cart)
    }else{
        await refreshCartOrderIds()
    }
  }
}

// Browser Back restores this page from bfcache with the same JS state: start a new OrderID so the
// next add-to-cart is a new line (an edited cart line, edit_line, is checked again on submit).
window.addEventListener('pageshow', function(e){
  if(e.persisted){
    order_id = newOrderId()
    // the QR file is per OrderID: regenerate it so this new line does not reuse the previous line's qr_<id>.png
    if($('#qr-input').val()){
      createQr()
    }
    refreshCartOrderIds()
  }
})

var star_map_color_or = '#000000'
$(document).ready(function(){
  addInspiration()

  // default message ❤ shown as Twemoji too, like the print
  if(window.twemoji && $('.custom-textarea').length){
	twemoji.parse($('.custom-textarea')[0], twemoji_options)
  }

  cart_loaded = fetch(window.Shopify.routes.root + 'cart.js')
.then(response => {
  return response.json();
}).then(response => {
  // true: change_style keeps the product, picked below (a ?variant= link keeps its variant)
  $('.grid__picker.style_picker .elem__picker').eq(0).trigger('click', [true])
  console.log(response);
  $('div#print').css('min-height', $('.custom-frame').outerHeight()+20+'px')
  setCartOrderIds(response)
  if(!selectVariantPickers(variantOptions(new URLSearchParams(window.location.search).get('variant')))){
    $('[data-state="Tablou__picker"]').click()
  }
})
.catch((error) => {
  console.error('Error:', error);
});
  
  $("input[name='categories']").on('change', function(){
	addInspiration()	
  })
  
  function addInspiration() {
        if ($("input[name='categories']:checked").val()) {
            var a = $("input[name='categories']:checked").val();
            var e = [];
            for ($('.modal-body').empty(),
            k = 0; k < inspiration[a].length; k++)
                e.push(inspiration[a][k]);
            for (i = 0; i < e.length; i++)
                $('.modal-body').append("<a class='list-group-item list-group-item-action saying-item' data-toggle='list' role='tab' aria-controls='home'><p class='text-center mb-0 pre'><small>" + e[i].replace(/(?:\r\n|\r|\n)/g, "<br>") + "</small></p></a>")
        }
    }

$(document).on('click','.saying-item', function(){
  $(".saying-item.active").removeClass('active');
  $(this).addClass('active')
})

  $(document).on('click','label.btn.btn-modal', function(){
  $("label.btn.btn-modal.active").removeClass('active');
  $(this).addClass('active')
})

$('.open_ins_modal').on('click', function(){
  $('.modal-backdrop.fade').show().addClass('show')
  $("#exampleModalCenter").fadeIn('800', function(){
    $(this).addClass('show')
  })
})  

  function closeModal(){
    $("#exampleModalCenter").fadeOut('800', function(){
    $(this).removeClass('show');
    $('.modal-backdrop.fade').removeClass('show').hide()
  })
  }

  $(document).on('click','.modal-content button.close, .modal-backdrop', function(){closeModal()})

$("#confirmSaying").on("click", function() {
  closeModal()
  var a = $(".saying-item.active");
  if (a.length > 0) {
    var i = a.children().children().html().replace(/<br\s*\/?>/gi, "\n").replace("&amp;", "&");
    $('textarea#textMessage').val(i),
    $('textarea#textMessage').trigger('input')
    $('textarea#textMessage').trigger('keydown')
  }
})

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
      let value_order = params.order_id;

      if(value_order){
        (async () => {
            var content = null
            try {
                const rawResponse = await fetch(proxy_loc+'star-map-data/?order_no='+value_order, {
                  method: 'GET'
                });
                content = rawResponse.ok ? await rawResponse.json() : null;
            } catch(error) {
                console.error('Saved map not loaded:', error);
            }

            // The design is loaded as a copy under this page's new OrderID, so a saved/ordered record is never
            // overwritten. When its line is still in the cart (edit flow: the line the "Editează" link was for,
            // by its &variant=), add-to-cart replaces that line.
            await cart_loaded

            // No such record (404, the server's error page, network error): the page stays a fresh editor
            if(!content || !content.order){
                saved_map_missing = true
                if(!$('.state_1.active__picker').length){
                    $('[data-state="Tablou__picker"]').click()
                }
                // initMap left the date labels to the restore; once the pickers are filled, sync them as it does
                if($('.bear-dates option').length){
                    try { changeDateTime() } catch(e) { console.warn('initial date sync failed', e) }
                }
                return
            }

            var restore_lines = cart_lines.filter(x => content.order && x.order_id == content.order),
            restore_line = restore_lines.filter(x => x.variant_id == params.variant)[0] || restore_lines[0]
            edit_line = restore_line ? { order_id: restore_line.order_id, variant_id: restore_line.variant_id } : null

            console.log(content);
            $('.grid__picker.style_picker .elem__picker').each(function(){
                if($(this).text().trim() == content.model){
                  $(this).trigger('click', [true])
                }
            })
            // Reopen the same product: ?variant= (cart edit link), else the edited cart line, else the saved size
            // (the default Tablou if nothing is picked yet, i.e. cart.js failed)
            if(![variantOptions(params.variant), restore_line && variantOptions(restore_line.variant_id), sizeOptions(content.size)].some(options => selectVariantPickers(options)) && !$('.state_1.active__picker').length){
                $('[data-state="Tablou__picker"]').click()
            }

            $('input#address_form1').val(content.location)
			$('#custom_address').val(content.address)
            $('span#custom_add').html(content.address)

            let only_date = content.date,
            date = only_date.split(' ')[0],
            month = only_date.split(' ')[1],
            year = only_date.split(' ')[2];

            let only_time = content.time,
            hrs = only_time.split(' ')[0],
            mins = only_time.split(' ')[1],
            am_pm = only_time.split(' ')[2];

            $('.bear-dates').val(date)
            $('.bear-months').val(month)
            $('.bear-years').val(year)

            $('.hours-dropdown').val(hrs)
            $('.minutes-dropdown').val(mins)
            $('label[for="timePickerMeridian'+am_pm+'"]').click()

            // an old "NaN S" / "NaN W" (saved from an emptied field) restores as an empty field with N / E, so the
            // values typed to fix it don't take the S / W of a number that never existed
            var saved_lat = content.lat.split(' '),
            saved_long = content.long.split(' ');
            if(isNaN(parseFloat(saved_lat[0]))){ saved_lat = ['', 'N'] }
            if(isNaN(parseFloat(saved_long[0]))){ saved_long = ['', 'E'] }

            $('#custom_lat_input input').val(saved_lat[0])

            $('#custom_lat_input select').val(saved_lat[1])

            $('#custom_lng_input input').val(saved_long[0])

            $('#custom_lng_input select').val(saved_long[1])

             $('.bear-years').val(year).trigger('change')

            // nullable column: null (admin edit, import) is "no image", as "" is
            var custom_image_url = content.custom_image_url || ''
            if(!custom_image_url.includes(preview_thumb_upload)){
                $('#image_code').click()
                $('#bg-img-new').prop('src', custom_image_url)
            }

			if(content.border){
				$('.grid__picker.custom_border .elem__picker').eq(1).click()
			}

            if(content.qr_text){
                $('#qrCodeSlide').click()
                $('#qr-input').val(content.qr_text).trigger('change')
                $('#qrcode').html('<img src="'+content.qr_url+'" />')
            }

			if(content.shape){
				$('[data-shape="'+content.shape+'"]').click()
			}

            $('#textTitle').val(content.title)
            $('#skyMap').html(content.title)
            if(window.twemoji){ twemoji.parse(document.getElementById('skyMap'), twemoji_options) }

            // $('#textMessage').val(content.message.replaceAll('<br>', "\n")).trigger('keydown')
            // $('.custom-textarea').html(content.message)
            // let s = content.message
            var s = ''+content.message;
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = s;

            $('.custom-textarea').html(htmlObject.innerHTML)
            // var i = htmlObject.innerHTML.replace(/<br\s*\/?>/gi, "\n").replace("&amp;", "&");
            console.log(content.message_preview)
			document.querySelector('textarea#textMessage').value = content.message_preview
            $('textarea#textMessage').trigger('input')
            $('textarea#textMessage').trigger('keydown')

			$('#mat-input-7').val(fixSavedTimeLabel(content.date_time, hrs, am_pm))
			restoreDateLabel(date, month, year, hrs, mins, am_pm)

			$('#custom_lat_long').val(content.coordinates).trigger('keyup')

			var elements = content.star_map_elements.split(','),
			constellation = elements[0].split(':')[1] == "true"?console.log('Already checked'):$('.celestialConstellation').click(),
			graticule = elements[1].split(':')[1] == "true"?$('.celestialGrid').click():console.log('Already checked'),
			milkyway = elements[2].split(':')[1] == "true"?$('.celestialMilkyWay').click():console.log('Already checked'),
			moon = elements[3].split(':')[1] == "true"?console.log('Already checked'):$('.celestialMoon').click(),
			constellationname= elements[4].split(':')[1] == "true"?$('.celestialConstellationNames').click():console.log('Already checked');
			map_color_present = content.background_color;

			document.querySelectorAll('.grid__picker.font_change_message .elem__picker p').forEach((x)=>{
			var rr = getComputedStyle(x).getPropertyValue("font-family");
				if(rr == content.message_font){
					x.click()
				}
			})
			
			document.querySelectorAll('.grid__picker.font_change_details .elem__picker p').forEach((x)=>{
			var rr = getComputedStyle(x).getPropertyValue("font-family");
				if(rr == content.details_font){
					x.click()
				}
			})

			

			$('input.input-email').val(content.email)
			setTimeout(()=>{
				$('.custom-frame.bg-new.shadow.text-center.p-3').css('background-color', content.background_color)

				lightOrDark(content.background_color, 'background') == 'dark'?changeTextToDarkColor(content.background_color):changeTextToLightColor(content.background_color)

				if(content.bg_image_url){
					$('.custom-frame.bg-new.shadow.text-center.p-3').css('background-image', 'url("'+content.bg_image_url.replace(/(["\\])/g, '\\$1')+'")')
					markBackgroundTile(content.bg_image_url)
				}

				if($('#bg-img-new').prop('src') == window.location.href.replaceAll('#','')){
					$('#bg-img-new').hide()
				}

				changeBackgroundColor(content.background_color)

				console.log(lightOrDark(content.star_map_color, 'map'))
				$('#background-fill').val(content.star_map_color)
				trigger_change_event("background-fill");
				setTimeout(()=>{
					Celestial.location([content.lat.includes('N')? content.lat.replaceAll(' N','').replaceAll(' S',''):parseFloat(content.lat.replaceAll(' N','').replaceAll(' S',''))*-1, content.long.includes('E')? content.long.replaceAll(' E','').replaceAll(' W',''):parseFloat(content.long.replaceAll(' W','').replaceAll(' E',''))*-1])
					// The saved sky is drawn: no need to search the place again (place_changed would also
					// overwrite the saved custom address and coordinates labels)
					if(savedLocationChosen(content.lat, content.long)){
						enableAddToCart()
					}
				},800)
			}, 100)
          })();
      }

    $(".Click-here").on('click', function() {
        $(".custom-model-main").addClass('model-open');
    }); 

    $(".close-btn, .bg-overlay").click(function(){
        $(".custom-model-main").removeClass('model-open');
    });



	// Initialize S3 Direct Upload (replaces UploadCare)
	// The S3DirectUploader class is defined in s3-direct-uploader.js
	let circularImageUploader;
	let backgroundImageUploader;

	// Function to initialize uploaders
	function initializeS3Uploaders() {
		// Check if S3DirectUploader class is available
		if (typeof S3DirectUploader === 'undefined') {
			console.error('S3DirectUploader class not found. Make sure s3-direct-uploader.js is loaded.');
			return;
		}

		// Check if input elements exist
		const imgInput = document.getElementById('my-img-input');
		const bgInput = document.getElementById('my-bg-input');

		if (!imgInput || !bgInput) {
			console.warn('Upload input elements not found yet, retrying...');
			setTimeout(initializeS3Uploaders, 200);
			return;
		}

		// Initialize circular image uploader (1:1 aspect ratio)
		circularImageUploader = new S3DirectUploader('my-img-input', 'bg-img-new', '1:1');

		// Initialize background image uploader (3:4 aspect ratio)
		backgroundImageUploader = new S3DirectUploader('my-bg-input', 'custom-frame-bg', '3:4');

		console.log('✓ S3 uploaders initialized successfully');
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initializeS3Uploaders);
	} else {
		// DOM already loaded
		setTimeout(initializeS3Uploaders, 100);
	}

	$('.time__picker').dateAndTime();

	$('.switcher__wrapper .switch input').on("change" ,function(e){
		if ($(this).prop('checked') == true) {
			$(this).closest('.switcher__wrapper').find('.row__input--main').removeClass("disabled__row");
		} else{
			$(this).closest('.switcher__wrapper').find('.row__input--main').addClass("disabled__row");
		}
	});



	$(".head__settings").on("click" ,function(e){
		e.preventDefault();
		var currentIndex = $(this).closest('.element__settings').index();
		$(".element__settings").each(function(index,elem){
			if (index != currentIndex) {
				$(elem).removeClass("active__settings");
				$(elem).find('.content__settings').slideUp(250);
			}
		});
		$(this).closest(".element__settings").toggleClass("active__settings");
		if ($(this).closest(".element__settings").hasClass("active__settings")) {
			$(".mobile__menu ul li").removeClass("active__mobile");
			$(".mobile__menu ul li").eq($(".active__settings").index()).addClass("active__mobile");
		}
		$(this).closest(".element__settings").find(".content__settings").slideToggle(250);
		$(".image__circle").each(function(index,elem){
			$(this).css("height" ,$(this).outerWidth()+'px');
		});
		if ($(this).closest(".element__settings").hasClass("active__settings")) {
			$(this).closest(".element__settings").addClass("visited");
		}
	});
	$(".elem__picker").on("click" ,function(e){
		//e.preventDefault();
		if (!$(this).closest(".grid__picker").hasClass("multiple__picker")) {
			$(this).closest(".grid__picker").find(".elem__picker").removeClass("active__picker");
			$(this).addClass('active__picker');
            console.log($(this).attr("data-state"))
			if ($(this).hasClass("elem__state")) {
                $('.add__cart--price p').show();
				$(".state__picker[data-state="+ $(this).attr("data-state") +"]").fadeIn(250);
				$(".image__circle").each(function(index,elem){
					$(this).css("height" ,$(this).outerWidth()+'px');
				});
                $(".state__picker.state_2[data-state="+ $(this).attr("data-state") +"] .elem__picker").eq(0).click()
                $(".state__picker.state_3[data-state="+ $(this).attr("data-state") +"] .elem__picker").eq(0).click()
                if($(this).attr("data-state").includes('Canvas') || $(this).attr("data-state").includes('Digital')){
                  $('.picker__wrapper.state__picker.state_3').hide();
                }else{
                  $(".state__picker.state_3[data-state="+ $(this).attr("data-state") +"]").show();
                }
			}
			$(this).closest(".grid__picker").find(".elem__picker").each(function(index,elem){
				if ($(elem).hasClass("elem__state")) {
					if (!$(elem).hasClass("active__picker")) {
						$(".state__picker[data-state="+ $(elem).attr("data-state") +"]").css("display" ,"none");
					}
				}
			});

          console.log($(this).parent())

          if($(this).hasClass("state_1")){
            $('.single-option-selector option[value="'+$(".state_1.active__picker .info__picker p").text().trim()+'"]').prop('selected', true).trigger('change')
          }

          if($(this).parent().parent().hasClass("state_2")){
            $('.single-option-selector option[value="'+$(".state__picker.state_2[data-state='"+$('.state_1.active__picker').data("state")+"'] .active__picker .info__picker p").text().trim()+'"]').prop('selected', true).trigger('change')
          }

          if($(this).parent().parent().hasClass("state_3")){
            $('.single-option-selector option[value="'+$(".state__picker.state_3[data-state='"+$('.state_1.active__picker').data("state")+"'] .active__picker .info__picker p").text().trim()+'"]').prop('selected', true).trigger('change')
          }
		} else {
			$(this).toggleClass("active__picker");
		}
	});

	$(".image__circle").each(function(index,elem){
		$(this).css("height" ,$(this).outerWidth()+'px');
	});

	$(window).on("resize" ,function(){

      
    // Store the window width
    var windowWidth = $(window).width();

    // Resize Event
    $(window).resize(function(){

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {

            // Update the window width for next time
            windowWidth = $(window).width();

            // Do stuff here

          $(".image__circle").each(function(index,elem){
			$(this).css("height" ,$(this).outerWidth()+'px');
		});
		if ($(window).width() < 991 && $(".visited").length != $(".element__settings").length) {
			$(".next__step").css("display" , "inline-flex");
			$('.submit__form').css("display" , "none");
		}
		if ($(window).width() > 991 && $(".element__settings").length) {
			$('.element__settings').css('display' , "block");
		}
		if ($(window).width() < 991 && $(".element__settings").length) {
			$('.element__settings').css("display" , "none");
			$('.element__settings.active__settings').css("display" ,"block");
		}
		if ($(window).width() < 991 && $('.active__settings').length == 0){
			$('.active__mobile').removeClass("active__mobile");
		}

        }

        // Otherwise do nothing

    });
      console.log('Resized')
		

		$('div#print').css('min-height', $('.custom-frame').outerHeight()+20+'px')

	});
	if ($(window).width() < 991 && $(".visited").length != $(".element__settings").length) {
		$(".next__step").css("display" , "inline-flex");
		$('.submit__form').css("display" , "none");
	}

	$(".mobile__menu ul li a").on("click" ,function(e){
		e.preventDefault();
      console.log('Li a clicked')
		$(".mobile__menu ul li").removeClass("active__mobile");
		$(this).closest("li").addClass("active__mobile");
		$(".element__settings").css("display" , "none");
		$(".element__settings").removeClass("active__settings");
		$(".content__settings").css("display" , "none");
		$(".element__settings").eq($(this).closest('li').index()).find(".content__settings").fadeIn(300);
		$(".element__settings").eq($(this).closest('li').index()).addClass("active__settings");
		$(".element__settings").eq($(this).closest('li').index()).addClass("visited");
		$(".element__settings").eq($(this).closest('li').index()).fadeIn(250);
		$(".image__circle").each(function(index,elem){
			$(this).css("height" ,$(this).outerWidth()+'px');
		});
		if ($(this).closest('li').index() == $(".mobile__menu ul  li").length  - 1) {
			$(".next__step").css("display" , "none");
			$('.submit__form').css("display" , "inline-flex");
		} else {
			$(".next__step").css("display" , "inline-flex");
			$('.submit__form').css("display" , "none");
		}
	});
	$(".next__step").on("click" ,function(e){
		e.preventDefault();
console.log('next step a clicked')
		$(".mobile__menu ul li.active__mobile").removeClass("active__mobile")
																					 .next().addClass("active__mobile");
		$(".element__settings").css("display" , 'none');																			 
        $(".element__settings").eq($(".active__mobile").index()).fadeIn(250);
        if (!$('.active__mobile').next().length) {
        	$(".next__step").css("display" , "none");
			$('.submit__form').css("display" , "inline-flex");
        }
	});

    Celestial.display({

		width: 1080,
        projection: "airy",
        transform: "equatorial",
        center: null,
        geopos: null,
        follow: "zenith",
        orientationfixed: true,
        zoomlevel: null,
        zoomextend: 10,
        adaptable: true,
        interactive: false,
        location: false,
        formFields: {
            location: true,
            general: true,
            stars: true,
            dsos: true,
            constellations: true,
            lines: true,
            other: true,
            download: true
        },
        advanced: true,
        daterange: [],
        settimezone: true,
        controls: false,
        lang: "",
        culture: "",
        container: "celestial-map",
        stars: {
            show: true,
            limit: 6,
            colors: false,
            style: {
                fill: "#ffffff",
                opacity: 1
            },
            designation: false,
            designationType: "desig",
            designationStyle: {
                fill: "#ddddbb",
                font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                align: "left",
                baseline: "top"
            },
            designationLimit: 2.5,
            propername: false,
            propernameType: "name",
            propernameStyle: {
                fill: "#ddddbb",
                font: "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                align: "right",
                baseline: "bottom"
            },
            propernameLimit: 1.5,
            size: 12,
            exponent: -.29,
            data: "stars.6.json"
        },
        dsos: {
            show: false,
            limit: 6,
            colors: true,
            style: {
                fill: "#cccccc",
                stroke: "#cccccc",
                width: 2,
                opacity: 1
            },
            names: true,
            namesType: "desig",
            nameStyle: {
                fill: "#cccccc",
                font: "11px 'Lucida Sans Unicode', 'DejaVu Sans', Helvetica, Arial, serif",
                align: "left",
                baseline: "bottom"
            },
            nameLimit: 4,
            size: null,
            exponent: 1.4,
            data: "dsos.bright.json",
            symbols: {
                gg: {
                    shape: "circle",
                    fill: "#ff0000"
                },
                g: {
                    shape: "ellipse",
                    fill: "#ff0000"
                },
                s: {
                    shape: "ellipse",
                    fill: "#ff0000"
                },
                s0: {
                    shape: "ellipse",
                    fill: "#ff0000"
                },
                sd: {
                    shape: "ellipse",
                    fill: "#ff0000"
                },
                e: {
                    shape: "ellipse",
                    fill: "#ff0000"
                },
                i: {
                    shape: "ellipse",
                    fill: "#ff0000"
                },
                oc: {
                    shape: "circle",
                    fill: "#ff9900",
                    stroke: "#ff9900",
                    width: 2
                },
                gc: {
                    shape: "circle",
                    fill: "#ff9900"
                },
                en: {
                    shape: "square",
                    fill: "#ff00cc"
                },
                bn: {
                    shape: "square",
                    fill: "#ff00cc"
                },
                sfr: {
                    shape: "square",
                    fill: "#cc00ff"
                },
                rn: {
                    shape: "square",
                    fill: "#0000ff"
                },
                pn: {
                    shape: "diamond",
                    fill: "#00cccc"
                },
                snr: {
                    shape: "diamond",
                    fill: "#ff00cc"
                },
                dn: {
                    shape: "square",
                    fill: "#999999",
                    stroke: "#999999",
                    width: 2
                },
                pos: {
                    shape: "marker",
                    fill: "#cccccc",
                    stroke: "#cccccc",
                    width: 1.5
                }
            }
        },
        constellations: {
			show: true,    // Show constellations 
        	names: false,     // Show constellation names 
			namesType: "iau", // Type of name Latin (iau, default), 3 letter designation (desig) or other language (see list below)
			nameStyle: { fill:"#ffffff", align: "center", baseline: "middle", opacity: .8,
						font: ["20px Open Sans, Arial, sans-serif",  // Style for constellations
								"15px Open Sans, Arial, sans-serif",  // Different fonts for diff.
								"15px Open Sans, Arial, sans-serif"]},// ranked constellations
			lineStyle: { stroke: "#cccccc", width: 1, opacity: 0.75 }, 
            lines: true,
            bounds: false,
            boundStyle: {
                stroke: "#ccff00",
                width: 2,
                opacity: .8,
                dash: [2, 6]
            }
        },
        mw: {
            show: false,
            style: {
                fill: "#ffffff",
                opacity: "0.15"
            }
        },
        lines: {
            graticule: {
                show: false,
                stroke: "#949494",
                width: 2.8,
                opacity: .7,
                lon: {
                    pos: [],
                    fill: "#eee",
                    font: "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                },
                lat: {
                    pos: [],
                    fill: "#eee",
                    font: "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                }
            },
            equatorial: {
                show: false,
                stroke: "#aaaaaa",
                width: 1.3,
                opacity: .7
            },
            ecliptic: {
                show: false,
                stroke: "#66cc66",
                width: 1.3,
                opacity: .7
            },
            galactic: {
                show: false,
                stroke: "#cc6666",
                width: 1.3,
                opacity: .7
            },
            supergalactic: {
                show: false,
                stroke: "#cc66cc",
                width: 1.3,
                opacity: .7
            }
        },
        horizon: {
            show: false,
            stroke: "#cccccc",
            width: 1,
            fill: "#000000",
            opacity: .4
        },
        daylight: {
            show: false
        },
        planets: {
            show: true,
            which: ["ter", "lun"],
            symbols: {
                sol: {
                    symbol: "\u2609",
                    letter: "Su",
                    fill: "#ffff00",
                    size: 12
                },
                mer: {
                    symbol: "\u263F",
                    letter: "Me",
                    fill: "#cccccc"
                },
                ven: {
                    symbol: "\u2640",
                    letter: "V",
                    fill: "#eeeecc"
                },
                ter: {
                    symbol: "\u2295",
                    letter: "T",
                    fill: "#00ccff"
                },
                lun: {
                    symbol: "\u25CF",
                    letter: "L",
                    fill: "#ffffff",
                    size: 40
                },
                mar: {
                    symbol: "\u2642",
                    letter: "Ma",
                    fill: "#ff6600"
                },
                cer: {
                    symbol: "\u26B3",
                    letter: "C",
                    fill: "#cccccc"
                },
                ves: {
                    symbol: "\u26B6",
                    letter: "Ma",
                    fill: "#cccccc"
                },
                jup: {
                    symbol: "\u2643",
                    letter: "J",
                    fill: "#ffaa33"
                },
                sat: {
                    symbol: "\u2644",
                    letter: "Sa",
                    fill: "#ffdd66"
                },
                ura: {
                    symbol: "\u2645",
                    letter: "U",
                    fill: "#66ccff"
                },
                nep: {
                    symbol: "\u2646",
                    letter: "N",
                    fill: "#6666ff"
                },
                plu: {
                    symbol: "\u2647",
                    letter: "P",
                    fill: "#aaaaaa"
                },
                eri: {
                    symbol: "\u26AA",
                    letter: "E",
                    fill: "#eeeeee"
                }
            },
            symbolStyle: {
                fill: "#cccccc",
                opacity: 1,
                font: "bold 17px 'DejaVu Sans Mono', 'Arial Unicode MS', sans-serif",
                align: "center",
                baseline: "middle"
            },
            symbolType: "symbol",
            names: false,
            nameStyle: {
                fill: "#cccccc",
                font: "14px 'Lucida Sans Unicode', 'DejaVu Sans', sans-serif",
                align: "right",
                baseline: "top"
            },
            namesType: "en"
        },

    	form: false,
		datapath: "https://data.skymap.website/static/celestial-data/",
		timezoneid: "OZJZSV28I4V8",
		background: {        // Background style
			fill: "#000000",   // Area fill
			opacity: 1, 
			stroke: "#ffffff", // Outline
			width: 2
		}
    });
  


});



var charactersPerLine=60;
var maxLines=5;
var textOutput="";
var onPaste=false;

function formatTextAsRequired() {
	/*
	This function handles two aspects:
	1. (a) READ VALUE from the textarea, (b) DETECT IF TEXT PER LINE IS TOO LONG  as required by the length restrictions, (c) PUSH OVERFLOWING TEXT from a line to the next line and (d) WRITE VALUE back to the textarea.
	2. (a) READ THE CURSOR POSITION to store the cursor position, and (b) POSITION THE CURSOR where a user would expect it after WRITE DATA.
	*/
	var textInput=document.getElementById("textMessage").value;//1a: READ VALUE
	var inputAsRows=textInput.split("\n");// create array from input => each element contains one row of the textarea
	var inputAsOneLine=textInput.replace(/(\r\n\t|\n|\r\t)/gm,"");//remove all line-breaks
	var cursorPositionOnInput=document.getElementById("textMessage").selectionStart;//2a: READ CURSOR POSITION
	var cursorOffsetAfterOutput=0;//set default value for cursor offset. cursor offset is needed when re-posiotioning the cursor after WRITE DATA
  
	var visibleCharactersPerLine=Math.floor((document.getElementById("textMessage").offsetWidth)/9);//number of visible characters per line before text breaks without a line-break. Depends on width of textarea and width of characters entered.
	var additionalTextAreaRows=0; //additional rows needed due to the text breaking
	
	var totalRows=inputAsRows.length; //don't put inputAsRows.length in the for statement, as the array is growing in the loop which results in an infinite loop
	var row;
	var lineBreakCount=0;
	var characterCount=0;
	for (row = 0; row < totalRows; ++row) {
	  if(inputAsRows[row].length>charactersPerLine){ //1b DETECT IF TEXT PER LINE IS TOO LONG 
		if (inputAsRows[row+1] === undefined) {
		  inputAsRows[row+1]="";// the row did not exist
		  totalRows++;
		  }
		//1c PUSH OVERFLOWING TEXT: move text that is too long for this row to the next row:
		inputAsRows[row+1]=inputAsRows[row].substring(charactersPerLine)+inputAsRows[row+1];
		inputAsRows[row]=inputAsRows[row].substring(0,charactersPerLine);
		//determine, if cursor was at the end of the line that got a line-break:
		var newOutput=inputAsRows.join("\n");
		if(newOutput.substr(cursorPositionOnInput-1,1)=="\n"){
		  cursorOffsetAfterOutput=1; }
		}
	  if(inputAsRows[row].length>visibleCharactersPerLine){ //1b DETECT IF TEXT PER LINE IS TOO LONG 
		additionalTextAreaRows=additionalTextAreaRows+Math.floor(inputAsRows[row].length/visibleCharactersPerLine);
		}
	  
	  }
  
	if(inputAsRows.length<=maxLines && inputAsOneLine.length<=(maxLines*charactersPerLine)){//data is within max number of rows and max total digits
	  textOutput=inputAsRows.join("\n");
	  document.getElementById("textMessage").rows=inputAsRows.length+additionalTextAreaRows;//resize textarea    
	  if(onPaste){
		cursorOffsetAfterOutput=cursorOffsetOnPaste(textInput,cursorPositionOnInput,totalRows)
		}
	  }
	  else //data would be too long 
	  {
	  cursorOffsetAfterOutput=-1;
	}
	document.getElementById("textMessage").value=textOutput;//1d: WRITE VALUE
	document.getElementById("textMessage").selectionStart=cursorPositionOnInput+cursorOffsetAfterOutput; //2b: POSITION CURSOR
	document.getElementById("textMessage").selectionEnd=cursorPositionOnInput+cursorOffsetAfterOutput; //set a single cursor, not a selection
	onPaste=false;
	
	 var value = document.getElementById("textMessage").value.replace(/\r\n|\r|\n/g,"<br />")
	$('.custom-textarea').html(value)
	twemoji.parse(document.getElementsByClassName('custom-textarea')[0],
	twemoji_options)
	// localStorage.setItem("save_mssg", document.getElementById("textMessage").value);
	// localStorage.setItem("save_mssg_1", $('.custom-textarea').html());
  }

  function trigger_change_event(element_id){
	element = document.getElementById(element_id);
	  var event = new Event('change');
	  element.dispatchEvent(event);
  }
  
  function change_constellations()
  {
	var showConst = $(".celestialConstellation").hasClass('active__picker')
	document.getElementById("constellations-lines").checked = showConst;
	trigger_change_event("constellations-lines")
	//setCookie('save_consti',showConst, 7);
  
  }
  
  function change_constellations_names(){
	var showConstNames = $(".celestialConstellationNames").hasClass('active__picker')
	document.getElementById("constellations-names").checked = showConstNames;
	trigger_change_event("constellations-names");
	//setCookie('save_constiN',showConstNames, 7);
  }
  
  function show_grid()
  {
	var showGrid = $(".celestialGrid").hasClass('active__picker')
	document.getElementById("lines-graticule-show").checked = showGrid;
	trigger_change_event("lines-graticule-show");
	//setCookie('save_grid',showGrid, 7);
  }
  
  function show_milkyway()
  {
	var showMoon = $(".celestialMilkyWay").hasClass('active__picker')
	document.getElementById("mw-show").checked = showMoon;
	trigger_change_event("mw-show");
	//setCookie('save_milky',showMoon, 7);
  }
  
  function show_moon()
  {
	var showMoon = $(".celestialMoon").hasClass('active__picker')
	document.getElementById("planets-show").checked = showMoon;
	trigger_change_event("planets-show");
	//setCookie('save_moon',showMoon, 7);
  }
  

  function checkElementsChange(){
	change_constellations()
	change_constellations_names()
	show_grid()
	show_milkyway()
	show_moon()
  }

  // keep_product: the page itself clicked the style while loading/restoring and picks the product;
  // a manual tap also keeps the chosen product unless it is Sky Light (style 2 only) or none is chosen
  function change_style(keep_product){
    var style = $('.style_picker .active__picker').index();
	console.log('Style Changed: '+style)
	var current_type = $('.state_1.active__picker').data('state')
	keep_product = keep_product || (current_type && current_type != 'Sky_Light__picker')
	if(style == 0){
        if(!keep_product){ $('[data-state="Tablou__picker"]').click() }
        $('.state_1, .final__step [data-state="'+$('.state_1.active__picker').data('state')+'"]').show()
        $('.hide-on-star').show()
		$('.hide_on_bg, .custom_iframe').show()
		$('.show_on_bg, [data-state="Sky_Light__picker"]').hide()
		$('.custom-frame').css('background-image', 'none')
        $('.custom-frame.bg-new.shadow.text-center.p-3').removeClass('skylight')
        $('.app__main').css('background-color', 'rgba(0,0,0,0)')
		changeBackgroundColor()
	}else if(style == 1){
        if(!keep_product){ $('[data-state="Tablou__picker"]').click() }
        $('.final__step [data-state="'+$('.state_1.active__picker').data('state')+'"], .state_1').show()
        $('.hide-on-star').show()
		$('.hide_on_bg, .custom_iframe, [data-state="Sky_Light__picker"]').hide()
		$('.show_on_bg').show()
		$('.pt-2.pb-1.frame-container.pl-0.pr-0').css('color', '#ffffff')
        $('.custom-frame.bg-new.shadow.text-center.p-3').removeClass('skylight')
        $('.app__main').css('background-color', 'rgba(0,0,0,0)')
		change_background_image()
	}else  if(style == 2){
        $('[data-state="Sky_Light__picker"]').click()
        $('.final__step [data-state]').hide()
        $('.state_2[data-state="Sky_Light__picker"]').show()
        $('[data-shape="1"]').click()
        $('.bg_map_color_change [data-color="#010203"]').click()
        $('.custom_border .elem__picker').eq(0).click()
        $('input#qr-input').val('').trigger('change')
        $('.star_map_color_change [data-color="#010203"]').click()
		$('.hide_on_bg, .custom_iframe').show()
		$('.show_on_bg, .hide_on_bg, .hide-on-star').hide()
		$('.custom-frame').css('background-image', 'none')
        $('.custom-frame.bg-new.shadow.text-center.p-3').addClass('skylight')
        $('.app__main').css('background-color', '#000')
	}
	// a kept Canvas / Format Digital has no frame picker, as when its type is clicked
	if(keep_product && style != 2 && /Canvas|Digital/.test($('.state_1.active__picker').data('state'))){
		$('.picker__wrapper.state__picker.state_3').hide()
	}

}  

// The background tile of a saved bg_image_url becomes the selected one (no click: that resets border, shape and
// colours), so tapping the style again keeps it. Fundal-2 is always saved as its per-size file on DigitalOcean.
function markBackgroundTile(url){
	var radio = $('[name="background-img"]').filter(function(){
		if($(this).data('id') == 'Fundal-2'){
			return /^https:\/\/skymapro-space\.fra1\.digitaloceanspaces\.com\/skymapro-space\/[^\/]*%20-%20bg\.png$/.test(url)
		}
		return this.value == url || $('label[for="'+this.id+'"] img').attr('data-full') == url
	}).first()
	if(radio.length){
		radio.prop('checked', true)
		radio.closest('.grid__picker').find('.elem__picker').removeClass('active__picker')
		$('label[for="'+radio.attr('id')+'"] .elem__picker').addClass('active__picker')
	}
}

function change_background_image(){
	// the picker img is a small thumbnail; the frame (and bg_image_url saved for print) gets the full file:
	// data-full, else the tile's radio value, else the src without its width= (never the thumbnail itself)
	var picker_img = $('.show_on_bg .active__picker img').eq(0)
	var src = picker_img.attr('data-full') || $('#'+picker_img.closest('label').attr('for')).val() ||
		String(picker_img.prop('src') || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '')
	$('.custom-frame').css('background-image', 'url("'+src+'")')
	$('.custom_border .elem__picker').eq(0).click()
	$('.shape_change_1 .elem__picker').eq(0).click()
	$('.bg_color_change .elem__picker').eq(0).click()	
	$('.bg_map_color_change .elem__picker').eq(0).click()
}

function change_font_message(){
	var font = $('.font_change_message .active__picker > .image__circle > p').css('font-family')
	$('.custom-textarea').css('font-family', font)
}

function change_font_details(){
	var font = $('.font_change_details .active__picker > .image__circle > p').css('font-family')
	$('.custom-address').css('font-family', font)
}


       
  function show_border(luminent){
    var showBorder = $('.custom_border .active__picker').index();
    var luminent = lightOrDark($('.custom-frame').css('background-color'), 'border')
	if(showBorder){
		if(luminent == 'light'){
			$(".pt-2.pb-1.frame-container").css('border','2px solid #000') ;
		}else{
			$(".pt-2.pb-1.frame-container").css('border','2px solid #fff') ;
		}
	}else{
		$(".pt-2.pb-1.frame-container").css('border','none') ;
	}
}  


  function changeStarMapColor(){
    if($('.star_map_color_change .elem__picker.active__picker').hasClass('custom_color_picker')){
        var map_color = $('.star_map_color_change .elem__picker #html5colorpickerstarmap').val()
    }else{
        var map_color = $('.grid__picker.star_map_color_change .elem__picker.active__picker .image__circle.image__color').data('color')
    }

    console.log(lightOrDark(map_color, 'map'))
    $('#background-fill').val(map_color)
    trigger_change_event("background-fill");
  }

  function changeStarAndConstellationToLightColor(){
    var config = {
            "stars": {
                "show": true,
                "limit": 6,
                "colors": false,
                "style": {
                    "fill": "#28282B",
                    "opacity": 1
                },
                "designation": false,
                "designationType": "desig",
                "designationStyle": {
                    "fill": "#28282B",
                    "font": "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "left",
                    "baseline": "top"
                },
                "designationLimit": 2.5,
                "propername": false,
                "propernameType": "name",
                "propernameStyle": {
                    "fill": "#28282B",
                    "font": "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "right",
                    "baseline": "bottom"
                },
                "propernameLimit": 1.5,
                "size": 12,
                "exponent": -0.29,
                "data": "stars.6.json"
            },
            "constellations": {
                "show": $('.celestialConstellation').hasClass('active__picker'),
                "names": $('.celestialConstellationNames').hasClass('active__picker'),
                "nameStyle": {
                    "fill": "#28282B",
                    "align": "center",
                    "baseline": "middle",
                    "opacity": 0.8,
                    "font": [
                        "20px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif"
                    ]
                },
                "lineStyle": {
                    "stroke": "#28282B",
                    "width": 1,
                    "opacity": 0.75
                },
                "lines": true,
                "bounds": false,
                "boundStyle": {
                    "stroke": "#28282B",
                    "width": 2,
                    "opacity": 0.8,
                    "dash": [
                        2,
                        6
                    ]
                }
            },
            "mw": {
                "show": $('.celestialMilkyWay').hasClass('active__picker'),
                "style": {
                    "fill": "#28282B",
                    "opacity": "0.15"
                }
            },
            "lines": {
                "graticule": {
                    "show": $('.celestialGrid').hasClass('active__picker'),
                    "stroke": "#808080",
                    "width": 2.2,
                    "opacity": 0.6,
                    "lon": {
                        "pos": [],
                        "fill": "#808080",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    },
                    "lat": {
                        "pos": [],
                        "fill": "#808080",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    }
                }
            },
            "planets": {
                "show": $('.celestialMoon').hasClass('active__picker'),
                "which": ["ter", "lun"],
                "symbols": {
                    "lun": {
                        "symbol": "\u25CF",
                        "letter": "L",
                        "fill": "#D3D3D3",
                        "size": 40
                    }
                }
            }
        }
    Celestial.reload(config)
  }


  function changeStarAndConstellationToDarkColor(){
    var config = {
            "stars": {
                "show": true,
                "limit": 6,
                "colors": false,
                "style": {
                    "fill": "#ffffff",
                    "opacity": 1
                },
                "designation": false,
                "designationType": "desig",
                "designationStyle": {
                    "fill": "#ddddbb",
                    "font": "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "left",
                    "baseline": "top"
                },
                "designationLimit": 2.5,
                "propername": false,
                "propernameType": "name",
                "propernameStyle": {
                    "fill": "#ddddbb",
                    "font": "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "right",
                    "baseline": "bottom"
                },
                "propernameLimit": 1.5,
                "size": 12,
                "exponent": -0.29,
                "data": "stars.6.json"
            },
            "constellations": {
                "show": $('.celestialConstellation').hasClass('active__picker'),
                "names": $('.celestialConstellationNames').hasClass('active__picker'),
                "nameStyle": {
                    "fill": "#ffffff",
                    "align": "center",
                    "baseline": "middle",
                    "opacity": 0.8,
                    "font": [
                        "20px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif"
                    ]
                },
                "lineStyle": {
                    "stroke": "#cccccc",
                    "width": 1,
                    "opacity": 0.75
                },
                "lines": true,
                "bounds": false,
                "boundStyle": {
                    "stroke": "#ccff00",
                    "width": 2,
                    "opacity": 0.8,
                    "dash": [
                        2,
                        6
                    ]
                }
            },
            "mw": {
                "show": $('.celestialMilkyWay').hasClass('active__picker'),
                "style": {
                    "fill": "#ffffff",
                    "opacity": "0.15"
                }
            },
            "lines": {
                "graticule": {
                    "show": $('.celestialGrid').hasClass('active__picker'),
                    "stroke": "#949494",
                    "width": 2.8,
                    "opacity": 0.7,
                    "lon": {
                        "pos": [],
                        "fill": "#eee",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    },
                    "lat": {
                        "pos": [],
                        "fill": "#eee",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    }
                }
            },
            "planets": {
                "show": $('.celestialMoon').hasClass('active__picker'),
                "which": ["ter", "lun"],
                "symbols": {
                    "lun": {
                        "symbol": "\u25CF",
                        "letter": "L",
                        "fill": "#ffffff",
                        "size": 40
                    }
                }
            }
        }

        Celestial.reload(config)
    }

    function changeTextToLightColor(map_color){
        $('.frame-container').css('color', '#000000')
        //$('.custom-frame.bg-new').css('background-color', map_color)
        

        $('.editor-color-53 .cust').css('fill', map_color)
        $('.editor-color-53 .cust').css('fill', map_color)
        $('.bor').css('fill','#000000')
        $('.strokeCouple').css('stroke','#000000')
		if($('.style_picker .elem__picker.active__picker').index() == 1){
			$('.frame-container').css('color', '#ffffff')
		}
    }

    function changeTextToDarkColor(map_color){
        $('.frame-container').css('color', '#ffffff')
        //$('.custom-frame.bg-new').css('background-color', '#fff')
        //$('.custom-frame.bg-new').css('color', '#000')
        $('.editor-color-53 .cust').css('fill', map_color)
        //$('.custom-frame.bg-new').css('color', '#fff')

        $('.editor-color-53 .cust').css('fill', map_color)
        $('.bor').css('fill','#ffffff')
        $('.strokeCouple').css('stroke','#ffffff')
		if($('.style_picker .elem__picker.active__picker').index() == 1){
			$('.frame-container').css('color', '#ffffff')
		}
    }

  
function lightOrDark(color, variant) {

    // Variables for red, green, blue values
    var r, g, b, hsp, m_color = color;
    
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        
        r = color[1];
        g = color[2];
        b = color[3];
    } 
    else {
        
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace( 
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>127.5) {
        if(variant == 'map'){
            changeStarAndConstellationToLightColor()
            star_map_color_or = m_color;
        }else if(variant == 'background'){
            setTimeout(()=>{
                changeTextToLightColor(color)
                show_border()
            }, 200)
        }
        return 'light';
    } 
    else {
        if(variant == 'map'){
            changeStarAndConstellationToDarkColor()
			star_map_color_or = m_color;
        }else if(variant == 'background'){
            setTimeout(()=>{
                changeTextToDarkColor(color)
                show_border()
            }, 200)
        }
        return 'dark';
    }

    
}

  function changeBackgroundColor(){
	//Check White Background
	console.log(map_color_present == '')
	if(map_color_present == ''){
		if($('.bg_map_color_change .elem__picker.active__picker').hasClass('custom_color_picker')){
			var map_color = $('.bg_map_color_change .elem__picker #html5colorpicker').val()
		}else{
			var map_color = $('.grid__picker.bg_map_color_change .elem__picker.active__picker .image__circle.image__color').data('color')
		}
	}else{
		map_color = map_color_present
	}
		console.log(lightOrDark(map_color, 'background'))
		console.log(map_color)

		$('.custom_color_bg').css('background-color',map_color)

		if($('.bg_color_change .elem__picker.active__picker').index() == 1){
			$('.custom-frame.bg-new').css('background-color', '#fff')
			$('.custom-frame.bg-new').css('color', '#000')
			$('.editor-color-53 .cust').css('fill', '#fff')
			$('.editor-color-53 .cust').css('fill', '#ffffff')
			$('.bor').css('fill','#000000')
			$('.strokeCouple').css('stroke','#000000')
			
		}else{
			$('.custom-frame.bg-new').css('background-color', map_color)
			$('.editor-color-53 .cust').css('fill', map_color)
			$('.custom-frame.bg-new').css('color', '#fff')

			$('.editor-color-53 .cust').css('fill', map_color)
			$('.bor').css('fill','#ffffff')
			$('.strokeCouple').css('stroke','#ffffff')
		}

		show_border()
  }

function lat_card(lat){
	var latitudeCardinal;
	var latitude = lat;
	if(lat >= 0){
	  latitudeCardinal = "N";
	}else{
	 latitudeCardinal = "S";
	 latitude = -1*lat;
	}

	$('#custom_lat_input input').val(latitude)
	$('#custom_lat_input select option[value="'+latitudeCardinal+'"]').prop('selected', true)
	return latitude + "˚ " + latitudeCardinal
  }
  
  function lng_card(lng){
	var longitudeCardinal;
	var longitude = lng;
	if(lng >= 0){
	  longitudeCardinal = "E";
	}else{
	  longitudeCardinal = "W";
	  longitude = -1*lng;
	}

	$('#custom_lng_input input').val(longitude)
   	$('#custom_lng_input select option[value="'+longitudeCardinal+'"]').prop('selected', true)
  	return longitude + "˚ " + longitudeCardinal
  }

  // typed: the point comes from the coordinate fields, not from a place chosen in the search
  function changeLocation(lat, lng, typed){
	// never label or move the sky from an invalid value (it printed "NaN˚ S" and switched the selects to S/W)
	if(!Number.isFinite(lat) || !Number.isFinite(lng)){
		return
	}
	Celestial.location([lat, lng])
	$('.custom-address #custom_lat_lng').html(lat_card(lat.toFixed(2))+", "+lng_card(lng.toFixed(2)))
    $('#custom_lat_long').val(lat_card(lat.toFixed(2))+", "+lng_card(lng.toFixed(2)))
	setCoordinateError('lat', false)
	setCoordinateError('lng', false)
	if(!typed){
		place_location = [lat, lng]
	}
	// a typed point far from the chosen place is usually a wrong N/S, E/W or swapped values
	$('#custom_coords_warning').prop('hidden', !(typed && place_location && distanceKm(place_location, [lat, lng]) > 100))
  }

  // last point set from a place chosen in the search (null for a restored map until a place is chosen)
  var place_location = null;

  // Typed coordinate -> number (a typed minus kept), NaN when empty, not a plain number or above max.
  // A dot or a comma is accepted as decimal separator, then a degree sign and a hemisphere letter, as Google Maps
  // and the poster label write it ("44.4268° N"): N/S for a latitude (max 90), E/W or V (vest) for a longitude.
  function parseCoordinate(val, max){
	var m = String(val == null ? '' : val).trim().match(/^([+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+))\s*[°˚º]*\s*([a-z]?)$/i)
	// a letter gives the hemisphere, so a minus with it is ambiguous
	if(!m || (m[2] && (m[1].charAt(0) == '-' || (max == 90 ? 'NS' : 'EWV').indexOf(m[2].toUpperCase()) < 0))){
		return NaN
	}
	var n = parseFloat(m[1].replace(',', '.'))
	return Math.abs(n) <= max ? n : NaN
  }

  // A valid typed "44.43 S" / "26.10 E": select its hemisphere and keep only the number in the field
  function applyTypedHemisphere(which, max){
	var input = $('#custom_'+which+'_input input'),
	val = $.trim(input.val()),
	letter = /[a-z]$/i.test(val) && !isNaN(parseCoordinate(val, max)) ? val.slice(-1).toUpperCase() : '';
	if(letter){
		$('#custom_'+which+'_input select').val(letter == 'V' ? 'W' : letter)
		input.val(val.replace(/\s*[°˚º]*\s*[a-z]$/i, ''))
	}
  }

  // which: 'lat' or 'lng'
  function setCoordinateError(which, invalid){
	// the error describes the field only while shown (screen readers read a referenced hidden text too)
	$('#custom_'+which+'_input input').attr('aria-invalid', invalid ? 'true' : 'false').attr('aria-describedby', invalid ? 'custom_'+which+'_error' : null)
	$('#custom_'+which+'_error').prop('hidden', !invalid)
	// the 100 km warning is about the point drawn, not about what an invalid field holds
	if(invalid){
		$('#custom_coords_warning').prop('hidden', true)
	}
  }

  // Both coordinate fields as [lat, lng] (NaN for an invalid one, sign not applied); shows or hides their inline errors
  function readCoordinates(){
	var lat = parseCoordinate($('#custom_lat_input input').val(), 90),
	lng = parseCoordinate($('#custom_lng_input input').val(), 180);
	setCoordinateError('lat', isNaN(lat))
	setCoordinateError('lng', isNaN(lng))
	return [lat, lng]
  }

  // great-circle distance in km between two [lat, lng] points
  function distanceKm(a, b){
	var rad = Math.PI / 180,
	h = Math.pow(Math.sin((b[0] - a[0]) * rad / 2), 2) +
		Math.cos(a[0] * rad) * Math.cos(b[0] * rad) * Math.pow(Math.sin((b[1] - a[1]) * rad / 2), 2);
	return 12742 * Math.asin(Math.min(1, Math.sqrt(h)))
  }

  function daytag(day){
    var daytag = "th";
    if(day == 1 || day == 21 || day == 31){
        daytag = "st";
    }else if(day == 2 || day == 22){
        daytag = "nd";
    }else if(day == 3 || day == 23){
        daytag = "rd";
    }else{
        daytag = "th";
    }
    return daytag;
  }

  // hrs is 0-23
  function timetag(hrs){
    var timetag = "am";
    if(hrs >= 12){
      timetag = "pm";
    }else{
      timetag = "am"
    }
    return timetag;

  }

  // 12h picker value ('01'-'12') + AM/PM -> 0-23 (12 AM = 0, 12 PM = 12)
  function to24h(hours, is_pm){
    var h = parseInt(hours, 10) % 12;
    return is_pm ? h + 12 : h;
  }

  // Maps saved before the 12 AM fix carry "... - 12:MM pm" in their date label; correct it on restore
  function fixSavedTimeLabel(label, hrs, am_pm){
    if(label && am_pm == 'AM' && parseInt(hrs, 10) == 12){
      return label.replace(/( - 12:\d{2} )pm$/, '$1am');
    }
    return label;
  }
  
  var months_en = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var months_ro = ['ianuarie','februarie','martie','aprilie','mai','iunie','iulie','august','septembrie','octombrie','noiembrie','decembrie'];

  // Date label printed on the poster, from the picker values (hours '01'-'12' + is_pm, minutes '00'-'59')
  // ro: "6 noiembrie 2025 - 05:30" (24h), en: "6th November 2025 - 5:30 am"; date only when with_time is false
  function formatDateLabel(lang, date, month, year, hours, minutes, is_pm, with_time){
    var day = parseInt(date, 10)
    var hours_24 = to24h(hours, is_pm)
    if(lang == 'en'){
      return day+daytag(day)+" "+months_en[parseInt(month, 10)]+" "+year+(with_time ? " - "+parseInt(hours, 10)+":"+minutes+" "+timetag(hours_24) : "")
    }
    return day+" "+months_ro[parseInt(month, 10)]+" "+year+(with_time ? " - "+String(hours_24).padStart(2, "0")+":"+minutes : "")
  }

  // RO | EN toggle next to the date (preselected from the date_label_format section setting)
  function dateLabelLang(){
    return $('[name="date_label_lang"]:checked').val() == 'en' ? 'en' : 'ro'
  }

  // Language of a saved label: 'ro', 'en' or '' when it can't tell (numbers only, another language)
  function dateLabelLangOf(label){
    var s = (label || '').toLowerCase()
    if(/\b(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|septembrie|octombrie|noiembrie|decembrie)\b/.test(s)) return 'ro'
    if(/\b(january|february|march|april|may|june|july|september|october|november|december)\b|\d(st|nd|rd|th)\b|\d ?[ap]m\b/.test(s)) return 'en'
    // "august" in both languages: without an ordinal or am/pm it is the Romanian format
    if(/\baugust\b/.test(s)) return 'ro'
    return ''
  }

  // Last label changeDateTime (or a restore) generated, as {label, parts: formatDateLabel arguments after lang};
  // any other text in #mat-input-7 was typed by the customer
  var date_label_auto = null

  // Restored map: the saved label stays as it is (preview included), the toggle follows its language
  // (older maps are English), and it counts as generated only if the saved date and time produce it
  function restoreDateLabel(date, month, year, hrs, mins, am_pm){
    var label = $('#mat-input-7').val()
    $('#custom_date').text(label)
    var lang = dateLabelLangOf(label)
    if(lang){
      $('[name="date_label_lang"][value="'+lang+'"]').prop('checked', true)
    }
    var is_pm = am_pm == 'PM'
    var en = formatDateLabel('en', date, month, year, hrs, mins, is_pm, true)
    // [label, with_time]
    var generated = [
      [en, true],
      [en.replace(" - "+parseInt(hrs, 10)+":", " - "+hrs+":"), true], // before the padding fix: "05:30 am"
      [formatDateLabel('en', date, month, year, hrs, mins, is_pm, false), false],
      [formatDateLabel('ro', date, month, year, hrs, mins, is_pm, true), true],
      [formatDateLabel('ro', date, month, year, hrs, mins, is_pm, false), false]
    ].filter(x => x[0] === label)[0]
    date_label_auto = generated ? { label: label, parts: [date, month, year, hrs, mins, is_pm, generated[1]] } : null
  }

  $('#time_on').on('change', function(){
    changeDateTime()
  })

  $('[name="date_label_lang"]').on('change', function(){
    // never replace a label the customer typed by hand. A generated one is rewritten in the new language from
    // the date and time it was made from, not from the pickers (a restored map's pickers can hold other values),
    // and a date-only label stays date-only
    var auto = date_label_auto
    if(auto && $('#mat-input-7').val() === auto.label){
      auto.label = formatDateLabel.apply(null, [dateLabelLang()].concat(auto.parts))
      document.querySelector('input#mat-input-7').value = auto.label
      $('#custom_date').html(auto.label)
    }
  })

  function changeDateTime(){
	let timezone = Celestial.timezone()
	const element = $("#timePicker").timepicker()[0]
	const id = $(element).attr("id")
	let year = $('.bear-years').val()
	let month = $('.bear-months').val()
	let date = $('.bear-dates').val()
	let time = $("#timePicker").timepicker().getValue()
	var hours = $(element).find(".hours-dropdown")[0].value
	let minutes = $(element).find(".minutes-dropdown")[0].value;
	let is_pm = $(element).find("#" + id + "MeridianPM")[0].checked
	let hours_24 = to24h(hours, is_pm)
	const d = new Date(year, month, date, hours_24, minutes);
	Celestial.date(d, timezone)

    var with_time = document.getElementById('time_on').checked
    var label = formatDateLabel(dateLabelLang(), date, month, year, hours, minutes, is_pm, with_time)
    document.querySelector('input#mat-input-7').value = label
    $('#custom_date').html(label)
    date_label_auto = { label: label, parts: [date, month, year, hours, minutes, is_pm, with_time] }
  }


  var shapeName='Cerc';
  function change_shape(val){
   if(val.id == 'cb17'){
   shapeName = 'Cerc';
   $('.custom_iframe').html($('#abc_6').val())
   }else if(val.id == 'cb18'){
   shapeName = 'Fetita';
   $('.custom_iframe').html($('#abc_4').val())
   }else if(val.id == 'cb19'){
   shapeName = 'Baiat';
   $('.custom_iframe').html($('#abc_1').val())
   }else if(val.id == 'cb20'){
   shapeName = 'Stea';
   $('.custom_iframe').html($('#abc_3').val())
   }else if(val.id == 'cb21'){
   shapeName = 'Inima';
   $('.custom_iframe').html($('#abc_2').val())
   }else if(val.id == 'cb51'){
   shapeName = 'Cuplu';
   $('.custom_iframe').html($('#abc_7').val())
   }else if(val.id == 'cb52'){
   shapeName = 'Pisica';
   $('.custom_iframe').html($('#abc_8').val())
   }else if(val.id == 'cb53'){
   shapeName = 'Catel';
   $('.custom_iframe').html($('#abc_9').val())
   }else if(val.id == 'cb54'){
   shapeName = 'Compas';
   $('.custom_iframe').html($('#abc_10').val())
   }
   else{
   shapeName = 'Cerc';
   $('.custom_iframe').html($('#abc_6').val())
   }
   changeBackgroundColor()
  }

function initMap() {
	var input = document.getElementById('address_form1');
	var autocomplete = new google.maps.places.Autocomplete(input);

	dates('option');
	months('option');
	var d = new Date();
	var year = d.getFullYear();
	years('option', year-70, year+10);
	$("#timePicker").timepicker({});

	// Sync both date labels and the sky with the pickers' initial values, otherwise a customer
	// who never touches the date gets the hard-coded placeholder labels saved and printed.
	// Restored maps (?order_id=) keep their saved label.
	if(!new URLSearchParams(window.location.search).get('order_id') || saved_map_missing){
		$(function(){
			setTimeout(function(){
				try { changeDateTime() } catch(e) { console.warn('initial date sync failed', e) }
			}, 0)
		})
	}

    $('#custom_address').keyup(function(){
        $('#custom_add').html($(this).val())
    })

    $('#mat-input-7').keyup(function(){
        $('#custom_date').html($(this).val())
    })

    $('#custom_lat_long').keyup(function(){
        $('#custom_lat_lng').html($(this).val())
    })

	$('div#print').css('min-height', $('.custom-frame').outerHeight()+20+'px')
	google.maps.event.addListener(autocomplete, 'place_changed', function () {
      enableAddToCart()
	  var place = autocomplete.getPlace();
      $('#custom_address').val(input.value)
      $('#custom_add').html(input.value)
	  changeLocation(place.geometry.location.lat(), place.geometry.location.lng())

	  //Set place location to input
	  //document.getElementById('textLocation').value = document.getElementById('address_form1').value

	  let lat_1 = (place.geometry.location.lat()).toFixed(2);
	  let lng_1 = (place.geometry.location.lng()).toFixed(2);

	  let custom_lat = lat_card(lat_1)
	  let custom_long = lng_card(lng_1)
		  
	});
  }
  

  $('#custom_lat_input input, #custom_lat_input select, #custom_lng_input input, #custom_lng_input select').on('change', function(){
	applyTypedHemisphere('lat', 90)
	applyTypedHemisphere('lng', 180)
	var coords = readCoordinates(),
	custom_lat = coords[0],
	custom_lng = coords[1];

	// while a field is empty or invalid the sky and labels keep the last valid point
	if(isNaN(custom_lat) || isNaN(custom_lng)){
		return
	}

	// a typed minus means S / W; otherwise the N/S, E/W select gives the hemisphere
	if(custom_lat > 0 && $('#custom_lat_input select').val() == 'S'){
		custom_lat = -1 * custom_lat
	}
	if(custom_lng > 0 && $('#custom_lng_input select').val() == 'W'){
		custom_lng = -1 * custom_lng
	}

	changeLocation(custom_lat, custom_lng, true)

  })


 $("#timePicker").timepicker({
	onChange: function (value) {
		changeDateTime()
	}
 });

 $('.row__date--element select').on('change', function(){
	changeDateTime()
 })

 $('#textTitle').on('keyup', function(){
	$('#skyMap').html($(this).val())
	twemoji.parse(document.getElementById('skyMap'),
	twemoji_options)
 })

 $('#textMessage').on('input', function(e) {
	formatTextAsRequired()
  })


  var lines = 5;
  var linesUsed = $('#messageRows');

  $('#textMessage').keydown(function(e) {

	  newLines = $(this).val().split("\n").length;
	linesUsed.text('Rand: '+newLines+' / '+lines);

	  if(e.keyCode == 13 && newLines >= lines) {
		  linesUsed.css('color', 'red');
		  return false;
	  }
	  else {
		  linesUsed.css('color', '');
	  }
  });


// $("#textMessage").bind("paste", function(e){
// 	handlePaste()
// } );

$('.checkChangeElement .elem__picker').on('click', function(){
	setTimeout(()=>{
		checkElementsChange()
	},50)
})


$('.bg_color_change .elem__picker, .bg_map_color_change .elem__picker').on('click', function(){
	setTimeout(()=>{
		map_color_present = ""
		changeBackgroundColor()
	},50)
})

$('#html5colorpicker').on('change', function(){
	changeBackgroundColor()
})

$('.star_map_color_change .elem__picker').on('click', function(){
	setTimeout(()=>{
		changeStarMapColor()
	},50)
})

$('#html5colorpickerstarmap').on('change', function(){
	changeStarMapColor()
})





$('.custom_border .elem__picker').on('click', function(){
	setTimeout(()=>{
		show_border()
	},50)
})

$('.style_picker .elem__picker').on('click', function(e, keep_product){
	setTimeout(()=>{
		change_style(keep_product)
	},50)
})

$('.show_on_bg .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_background_image()
	},50)
})

$('.font_change_message .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_font_message()
	},50)
})


$('.font_change_details .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_font_details()
	},50)
})


$('#image_code').on('click', function(){
	if($(this).prop('checked')){
		$('img#bg-img-new').prop('src',image_upload_file).show()
		$('.custom-textarea').addClass('mt-6v')
	}else{
		$('img#bg-img-new').prop('src',preview_thumb_upload).hide()
		$('.custom-textarea').removeClass('mt-6v')
	}
})

$('#qrCodeSlide').on('click', function(){
	if($(this).prop('checked')){
		$('#qrcode').fadeIn();
        if($('div#qrcode img').length){
            $('div#qrcode img').prop('src',qr_url);
        }else if(qr_url){
            $('#qrcode').html('<img src="'+qr_url+'" />');
        }
	}else{
		$('#qrcode').fadeOut();
        $('div#qrcode img').prop('src','');
	}
})





// var qrcode = new QRCode(document.getElementById("qrcode"), {
// 	width : 1000,
// 	height : 1000,
// 	colorDark : '#000',
// 	colorLight : '#fff',
// 	correctLevel : QRCode.CorrectLevel.H
// });

function qrCreateUrl(text, id){
    return proxy_loc+'create-qr/?data='+encodeURIComponent(text)+'&id='+encodeURIComponent(id)
}

// The server keeps one file per order (media/qr_<order_id>.png) and overwrites it on every edit,
// so the image URL gets a version param: the preview and the print never show a cached old QR.
var qr_request = null;
function createQr(){
    var text = $('#qr-input').val();
    if (!text) {
        return Promise.resolve(qr_url);
    }
    qr_pending = true;
    var req = fetch(qrCreateUrl(text, order_id))
    .then(response => {
        if (!response.ok) {
            throw new Error('create-qr ' + response.status);
        }
        return response.json();
    })
    .then(data => {
        if (req !== qr_request) {
            return qr_url; // superseded by a newer request
        }
        qr_url = data.img_name + '?v=' + Date.now();
        if ($('#qrCodeSlide').prop('checked')) {
            document.getElementById("qrcode").innerHTML = `<img src="${qr_url}" />`;
        }
        return qr_url;
    })
    .catch(error => {
        console.error('Error:', error);
        if (req !== qr_request) {
            return qr_url;
        }
        // never keep a QR image that does not match the text / this OrderID
        qr_url = '';
        $('div#qrcode img').prop('src', '');
        alert('Codul QR nu a putut fi generat. Te rugăm să încerci din nou.');
        return qr_url;
    })
    .finally(() => {
        if (req === qr_request) {
            qr_pending = false;
        }
    });
    qr_request = req;
    return req;
}

$('#qr-input').on('change', function(e){
    e.preventDefault();
    createQr();
	// qrcode.makeCode(elText.value);
	// console.log(qrcode)
})

// call_run = 0
// prev_val = 0
// var myInterval;
// myInterval = setInterval(myTimer, 1000);
// Celestial.addCallback(function(e){
// 	call_run = call_run+1
	
// 	console.log(call_run)
	
// 	prev_val = call_run
// })

// function myTimer() {
// 	if(call_run == prev_val){
// 		console.log('Done')
// 		//myStopFunction() 
// 	}
// }

// function myStopFunction() {
//   clearInterval(myInterval);
// }


//Celestial.exportSVG( function(data) { console.log(data) })

$('.submit__form').on('click', function(e){
    e.preventDefault();
    submit_form('')
})

$('.btn-send-email').on('click', function(e){
    e.preventDefault();
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if ($('.input-email').val().match(validRegex)) {
      submit_form('?send_email=true')
      $('.ant-modal.popup-send-email .close-btn').click()
    }else{
      alert('Enter a valid email.')
    }
    
})



function submit_form(params){
  if (qr_pending) {
    alert('QR code is still generating, please wait a moment and try again.')
    return;
  }
  // a value typed but not applied yet (no change event before the tap) with a hemisphere letter, a degree sign or a
  // decimal comma: apply it as the change event does, so the saved lat / long stay "<number> <N|S>" and the
  // coordinates label and sky follow it. A plain number (a restored one too) is left as it is.
  $('#custom_lat_input input, #custom_lng_input input').filter(function(){ return !/^[+-]?\d+(\.\d+)?$/.test($.trim(this.value)) }).first().trigger('change')
  // an empty or invalid typed coordinate must not be saved (it was printed as "NaN˚ S")
  if (readCoordinates().some(isNaN)) {
    alert('Coordonatele introduse nu sunt valide. Te rugăm să le corectezi sau să alegi din nou locația.')
    return;
  }
  $('#cover-spin').show()
    // exportSVG never calls back if a celestial data file fails to load: don't leave the spinner up forever
    var export_timed_out = false;
    var export_timer = setTimeout(function(){
        export_timed_out = true;
        $('#cover-spin').hide();
        alert('A apărut o eroare la salvarea configurației. Te rugăm să încerci din nou.');
    }, 45000);
    Celestial.exportSVG( function(star_map_svg) {
        if(export_timed_out){
            return;
        }
        clearTimeout(export_timer);
        var mynewmssg = document.querySelector('.custom-textarea').innerHTML;
        
        if($('.custom-textarea br').length == 0){
            mynewmssg = "<br><br>"+document.querySelector('.custom-textarea').innerHTML+"<br><br><br>";
        }else if($('.custom-textarea br').length <= 1){
            mynewmssg = "<br><br>"+document.querySelector('.custom-textarea').innerHTML+"<br><br>";
        }else if($('.custom-textarea br').length <= 2){
            mynewmssg = "<br>"+document.querySelector('.custom-textarea').innerHTML+"<br><br>";
        }else if($('.custom-textarea br').length <= 3){
            mynewmssg = "<br>"+document.querySelector('.custom-textarea').innerHTML+"<br>";
        }else if($('.custom-textarea br').length <= 4){
            mynewmssg = document.querySelector('.custom-textarea').innerHTML+"<br>";
        }

        var bg_img = document.querySelector('.custom-frame'),
        style = bg_img.currentStyle || window.getComputedStyle(bg_img, false),
        bg_image_url = style.backgroundImage.slice(4, -1).replace(/"/g, "");

        

        // the QR image saved with this map (not the global qr_url: that one stays the last generated QR)
        var qr_save_url;
        let model = $('.style_picker .active__picker .info__picker').text().trim(),
        email = $('.input-email').val()
        address = $('#custom_address').val(),
        date = $('.bear-dates').val()+" "+$('.bear-months').val()+" "+$('.bear-years').val(),
        time = $('.hours-dropdown').val()+" "+$('.minutes-dropdown').val()+" "+$('[name="timePickerMeridian"]:checked+label').html(),
        date_time = $('#mat-input-7').val(),
        custom_image_url = ($('img#bg-img-new').prop('src').includes(preview_thumb_upload) || $('img#bg-img-new').prop('src').includes(window.location.host))? "": $('img#bg-img-new').prop('src'),
        qr_text = $('#qr-input').val(),
        qr_save_url = $('#qrcode img').attr('src') || "",
        title = $('input#textTitle').val(),
		custom_location = $('#address_form1').val().trim(),
        message = mynewmssg,
        message_preview = $('#textMessage').val(),
        lat = $('#custom_lat_input input').val()+" "+$('#custom_lat_input select').val(),
        long = $('#custom_lng_input input').val()+" "+$('#custom_lng_input select').val(),
        coordinates = $('#custom_lat_long').val(),
        constellations = $('.celestialConstellation').hasClass('active__picker'),
        grid = $('.celestialGrid').hasClass('active__picker'),
        milkyway = $('.celestialMilkyWay').hasClass('active__picker'),
        moon = $('.celestialMoon').hasClass('active__picker'),
        constellationNames = $('.celestialConstellationNames').hasClass('active__picker'),

        star_map_elements = "constellations:"+constellations+", grid:"+grid+", milkyway:"+milkyway+", moon:"+moon+", constellationNames:"+constellationNames,

        shape = $('.shape_change_1 .elem__picker.active__picker').data('shape'),
		shape_svg = $('.custom_iframe').html().trim(),

        background_color = $('.custom-frame').css('background-color'),

        text_color = $('.custom-frame .frame-container').css('color'),

        star_map_color = star_map_color_or,

        border = $('.custom_border .elem__picker.active__picker').index() == 1? true:false,

        message_font = $('.font_change_message .elem__picker.active__picker .image__circle p').css('font-family'),
        
        details_font = $('.font_change_details .elem__picker.active__picker .image__circle p').css('font-family');

        if($('[name="background-img"]:checked').data('id') == 'Fundal-2'){
          bg_image_url = `https://skymapro-space.fra1.digitaloceanspaces.com/skymapro-space/${$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().split(' ')[1]}%20-%20bg.png`;
        }

        if(bg_image_url.includes('Template_1.jpg')){
          bg_image_url = '';
          background_color = '#000'
        }

        (async () => {
            // Build cart formData before any network calls — all values come from DOM, not server
            var sel_type = $('.state_1.active__picker').data("state").split('__')[0].toUpperCase()
            var sel_frame = ''
            if($('.state_1.active__picker').data("state").split('__')[0] == 'Poster' && $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim() == 'Fara rama'){
                sel_type = 'POSTER'
            }else if($('.state_1.active__picker').data("state").split('__')[0] == 'Poster' && $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim() != 'Fara rama'){
                sel_type = 'POSTER';
                sel_frame = $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim();
            }else if($('.state_1.active__picker').data("state").split('__')[0] == 'Canvas'){
                sel_type = 'TABLOU CANVAS'
            }else if($('.state_1.active__picker').data("state").split('__')[0] == 'Sky Light'){
                sel_type = 'SKY LIGHT'
            }
            if($('.state_1.active__picker').data("state").split('__')[0] == 'Tablou'){
                sel_type = sel_type+" STICLA"
                sel_frame = 'Rama '+$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim()
            }
            var selected_size = 'Marimea '+$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().split(' ')[1];

            let formData = {
             'items': [{
              'id': $('#var_id').val(),
              'quantity': 1,
               "properties" : {
                  "OrderID": order_id,
                  "Data & Ora": date_time,
                  "Elemente": star_map_elements,
                  "Locatie": address,
                  "Mesaj": message_preview,
                  "Titlu": title,
                  "_print_url": "https://data.skymap.website/api/download/?orderId="+order_id+"&version="+Date.now(),
                  "_selected_type": sel_type,
                  "_selected_size": selected_size,
                  "_selected_frame": sel_frame
                }
              }]
            };

            let saveResp;
            try { saveResp = await fetch(proxy_loc+'star-map-data/'+params, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  "size": $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().split(' ')[1]?$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().split(' ')[1].replace('cm',''):"13x18",
                  "email": email,
                  "order": order_id,
                  "model": model,
				  "location": custom_location,
                  "address": address,
                  "date": date,
                  "time": time,
                  "date_time": date_time,
                  "custom_image_url": custom_image_url,
                  "qr_text": qr_text,
                  "qr_url": qr_save_url,
                  "bg_image_url": bg_image_url,
                  "title": title,
                  "message": message,
                  "message_preview": message_preview,
                  "lat": lat,
                  "long": long,
                  "coordinates": coordinates,
                  "star_map_elements": star_map_elements,
                  "shape": shape,
				  "shape_svg": shape_svg,
                  "background_color": background_color,
                  "text_color": text_color,
                  "star_map_color": star_map_color,
                  "border": border,
                  "message_font": message_font,
                  "details_font": details_font,
                  "svg_image": star_map_svg.replaceAll('/*&lt;![CDATA[*/','')
              })
            }); } catch(saveErr){
                console.error('Order save error:', saveErr);
                $('#cover-spin').hide();
                alert('A apărut o eroare la salvarea configurației. Te rugăm să încerci din nou.');
                return;
            }

            if(saveResp && !saveResp.ok){
                $('#cover-spin').hide();
                alert('A apărut o eroare la salvarea configurației ('+saveResp.status+'). Te rugăm să încerci din nou.');
                return;
            }

            if(params == ''){
                try {
                    await refreshCartOrderIds()
                    // Editing a cart line: add the new line first with all the units of the old one (Shopify may
                    // show them as several lines), then remove the old lines, so a failed add leaves the
                    // customer's lines, and their saved design, as they were
                    var old_lines = editedLines(cart_lines)
                    if(old_lines.length){
                        formData.items[0].quantity = old_lines.reduce((n, x) => n + x.quantity, 0)
                    }
                    const addResp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    });
                    if(!addResp.ok){
                        throw new Error('cart/add.js '+addResp.status)
                    }
                    if(old_lines.length){
                        try {
                            await removeEditedLines()
                        } catch(error) {
                            // the new line is in the cart; the old one stays there too, visible on /cart
                            console.error('Old cart line not removed:', error);
                        }
                    }
                    // This OrderID now belongs to the new cart line: the next add-to-cart is a new line
                    order_id = newOrderId()
                    edit_line = null
                    $('#cover-spin').hide();
                    window.location.href = '/cart';
                } catch(error) {
                    $('#cover-spin').hide();
                    console.error('Error:', error);
                    alert('A apărut o eroare la adăugarea în coș. Te rugăm să încerci din nou.')
                }
            }else{
                $('#cover-spin').hide();
                alert($('.email_success_text').val() || 'Ți-am trimis harta pe email.');
            }
          })().catch((error) => {
              $('#cover-spin').hide();
              console.error('Error:', error);
              alert('A apărut o eroare la salvarea configurației. Te rugăm să încerci din nou.');
          });
    })
    
}
